/**
 * Says so when the interface is in a translation nobody has reviewed — DECISIONS.md #54.
 *
 * I18N.md §7 puts a professional translation after the catalogue is frozen and the Swedish is
 * clinically reviewed. Until then the English and Spanish catalogues are placeholders, and a reader
 * has to be able to tell — a label that reads wrongly is less dangerous when the screen has said it
 * might. The flag is each catalogue's own `language.reviewed`, so a reviewed translation turns the
 * notice off by changing one value, with no code.
 *
 * About the labels only: record content is never translated (AGENTS.md §3 rule 8), and the notice
 * says that too.
 */

import { useTranslation } from 'react-i18next'

export function TranslationNotice() {
  const { t } = useTranslation('common')

  if (t('language.reviewed') !== 'no') {
    return null
  }

  return (
    <p className="translation-notice" role="note">
      {t('language.unreviewedNotice')}
    </p>
  )
}
